
import React from 'react'
import { Link } from 'react-router-dom'

interface BusinessSplitV2Props {
  currentLang: 'zh' | 'en'
}

const BusinessSplitV2: React.FC<BusinessSplitV2Props> = ({ currentLang }) => {
  const t = currentLang === 'zh'
    ? {
        roast: { title: 'BAISEN｜自家烘焙', cta: 'Read more', href: `/${currentLang}/roast-lab` },
        lab: { title: 'LAB｜醞玖製研中心', cta: 'Read more', href: `/${currentLang}/lab` },
        school: { title: 'BREWING｜沖煮體驗', cta: 'Read more', href: `/${currentLang}/store/xinyi` },
        consulting: { title: 'CONSULTING｜B2B 顧問', cta: 'Read more', href: `/${currentLang}/wholesale` },
      }
    : {
        roast: { title: 'BAISEN｜In-house Roasting', cta: 'Read more', href: `/${currentLang}/roast-lab` },
        lab: { title: 'LAB｜ONGU Research', cta: 'Read more', href: `/${currentLang}/lab` },
        school: { title: 'BREWING｜Hand Brew Experience', cta: 'Read more', href: `/${currentLang}/store/xinyi` },
        consulting: { title: 'CONSULTING｜B2B Advisory', cta: 'Read more', href: `/${currentLang}/wholesale` },
      }

  // Row 1: 35 / 65 split (BAISEN / LAB)
  // Row 2: 50 / 50 split (BREWING / CONSULTING)
  const row1 = [
    {
      ...t.roast,
      image: 'https://images.pexels.com/photos/894695/pexels-photo-894695.jpeg',
      width: 'narrow' as const,
    },
    {
      ...t.lab,
      image: 'https://file.lumi.new/p373839333138763776/SPF2016947172312682496.png',
      width: 'wide' as const,
    },
  ]
  const row2 = [
    {
      ...t.school,
      image: 'https://images.pexels.com/photos/1459339/pexels-photo-1459339.jpeg',
      width: 'half' as const,
    },
    {
      ...t.consulting,
      image: 'https://images.pexels.com/photos/1695052/pexels-photo-1695052.jpeg',
      width: 'half' as const,
    },
  ]

  const renderRow = (items: typeof row1) => (
    <div className="flex flex-col gap-2 md:flex-row">
      {items.map((item) => {
        const widthClass =
          item.width === 'wide'
            ? 'md:w-[65%]'
            : item.width === 'narrow'
              ? 'md:w-[35%]'
              : 'md:w-1/2'
        return (
          <Link
            key={item.title}
            to={item.href}
            className={`group relative block h-[215px] overflow-hidden ${widthClass}`}
          >
            <img
              src={item.image}
              alt={item.title}
              className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
            />
            <div className="absolute inset-0 bg-black/40 transition-colors duration-300 group-hover:bg-black/50" />
            <div className="absolute inset-0 flex flex-col items-center justify-center px-6 text-center">
              <h3
                className="mb-6 text-white"
                style={{
                  fontFamily: "'EB Garamond', 'Noto Serif TC', serif",
                  fontWeight: 400,
                  fontSize: 'clamp(1.125rem, 2vw, 1.625rem)',
                  letterSpacing: '0.06em',
                }}
              >
                {item.title}
              </h3>
              <span
                className="border-b border-white/80 pb-1 text-xs tracking-[0.2em] text-white"
                style={{ fontFamily: "'EB Garamond', serif" }}
              >
                {item.cta}
              </span>
            </div>
          </Link>
        )
      })}
    </div>
  )

  return (
    <section className="bg-[#FAF9F1] pb-2">
      <div className="flex w-full flex-col gap-2">
        {renderRow(row1)}
        {renderRow(row2)}
      </div>
    </section>
  )
}

export default BusinessSplitV2
